import React, { useState } from 'react';

import trashCan from '../assets/images/icons/trash-can.svg';

const ConfirmationOrderItem = ({ itemImg, itemName, itemSize, itemPrice, isDeletable, handleDeleteClick }) => {
  return (
    <div className="confirmation-order-item">
      <img className='item-image' src={itemImg} alt='item img'/>
      <p className='item-name'>{itemName}</p>
      {itemSize && <p style={{width: 114, textAlign: 'end'}}>Size {itemSize}</p>}
      <p style={ itemSize ? {width: 114, textAlign: 'end'} : {width: 248, textAlign: 'end'}}>{itemPrice} ADA</p>
      {isDeletable && <img className='delete-item-option' src={trashCan} onClick={handleDeleteClick}/>}
    </div>
  );
};

export default ConfirmationOrderItem;